exports = module.exports = require("../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":root{--color-primary:#1c84c6;--color-success:#1ab394;--color-warning:#f8ac59;--color-danger:#ed5565;--color-info:#3f5060;--color-disabled:#9099a0;--text-color-light:#fff;--text-color:#999;--text-color-dark:#676a6c;--bg-color-lighter:#fff;--bg-color-light:#f3f3f4;--bg-color:#3f5060;--bg-color-dark:#2f4050;--bg-color-darker:#293846;--bg-card:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/shopee-theme/dist/shopee/colors.css
// module id = 213
// module chunks = 0